<template>
    <form class="uk-form uk-overflow-container">
        <table class="uk-table lam-subrecords-list">
            <thead>
                <tr>
                    <th>
                        Service
                        <base-button
                            size="mini"
                            class="uk-margin-small-left"
                            @click.prevent="add_service"
                        >
                            <open-icon glyph="plus" />
                        </base-button>
                    </th>
                    <th>Description</th>
                    <th v-if="editable">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(phase_template_service, index) in phase_template_services"
                    :key="phase_template_service.service_id"
                >
                    <td class="uk-width-5-10">
                        <form-select
                            :id="`phase_template_service-${phase_template_service.service_id}`"
                            name="service_id"
                            v-model="phase_template_service.service_id"
                            :options="raw_service_records"
                            :editable="editable"
                            :required="true"
                            class="uk-width-1-1"
                            @input="save_phase_template_service_field(index, $event, 'service_id')"
                        />
                    </td>
                    <td v-if="editable" class="uk-width-5-10">
                        <form-select
                            v-if="phase_template_service_type(phase_template_service) === 'list'"
                            :id="`phase_template_service-service_description-${phase_template_service.service_id}`"
                            name="service_description"
                            v-model="phase_template_service.service_description"
                            :options="phase_template_service_types(phase_template_service)"
                            :editable="editable"
                            :required="true"
                            class="uk-width-1-1"
                            @input="save_phase_template_service_field(index, $event, 'service_description')"
                        />
                        <span
                            v-else-if="phase_template_service_type === 'boolean'"
                        >
                            n/a
                        </span>
                        <form-input
                            v-else
                            :id="`phase_template_service-service_description-${phase_template_service.service_id}`"
                            name="service_description"
                            v-model="phase_template_service.service_description"
                            :editable="editable"
                            :required="true"
                            class="uk-width-1-1"
                            @input="save_phase_template_service_field(index, $event, 'service_description')"
                        />
                    </td>
                    <td v-else class="uk-width-5-10">
                        <span
                            v-if="phase_template_service_type === 'boolean'"
                        >
                            n/a
                        </span>
                        <span v-else>{{ phase_template_service.service_description }}</span>
                    </td>
                    <td v-if="editable" class="uk-text-right">
                        <base-button
                            color="danger"
                            @click.prevent="remove_phase_template_service(index)"
                        >
                            <open-icon glyph="trash" />
                        </base-button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div
            v-if="!phase_template_services.length"
            class="uk-margin-top uk-margin-bottom uk-text-center"
        >
                <em class="uk-text-muted">(No records found)</em>
        </div>
    </form>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import handles_saving from "../mixins/HandlesSaving"

import FormSelect from "./FormSelect"
import FormInput from "./FormInput"
import BaseButton from "./BaseButton"
import OpenIcon from "./OpenIcon"

export default {
    mixins: [handles_saving],
    components: {
        FormSelect,
        FormInput,
        BaseButton,
        OpenIcon
    },
    mounted () {
        this.load()
    },
    methods: {
        load () {
            this.$store.dispatch("FETCH_RECORDS", { entity: "phase_template" })
            this.$store.dispatch("FETCH_RECORDS", { entity: "service" })
        },
        service_by_id (service_id) {
            return this.raw_service_records.find(service => service.id === service_id)
        },
        phase_template_service_type (phase_template_service) {
            const service = this.service_by_id(phase_template_service.service_id)
            if(service) return service.description_type
            return ""
        },
        phase_template_service_types (phase_template_service) {
            const service = this.service_by_id(phase_template_service.service_id)
            if(service && !!service.description) return service.description
            return []
        },
        save_phase_template_service_field (index, value, field) {
            const phase_template_services = this.phase_template_services
            phase_template_services[index][field] = value
            this.save_field_for_record_id("phase_template", this.phase_template.id, JSON.stringify({ "App\\Task": phase_template_services }), "content")
        },
        remove_phase_template_service (index) {
            const phase_template_services = this.phase_template_services
            phase_template_services.splice(index, 1)
            this.save_field_for_record_id("phase_template", this.phase_template.id, JSON.stringify({ "App\\Task": phase_template_services }), "content")
        },
        add_service () {
            const phase_template_services = this.phase_template_services
            phase_template_services.push({
                service_id: this.raw_service_records[0].id,
                service_description: ""
            })
            this.save_field_for_record_id("phase_template", this.phase_template.id, JSON.stringify({ "App\\Task": phase_template_services }), "content")
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_phase_template_records () {
            return this.entity_records("phase_template")
        },
        raw_service_records () {
            return this.entity_records("service")
        },
        phase_template () {
            const phase_template = this.raw_phase_template_records.find(phase_template => {
                return (phase_template.phase === this.phaseId) && (phase_template.service_level === this.serviceLevelId)
            })
            return phase_template || { content: "{\"App\\\\Task\": []}" }
        },
        phase_template_services () {
            if(!this.phase_template) return []
            const content = JSON.parse(this.phase_template.content)
            return content["App\\Task"] || []
        }
    },
    props: {
        phaseId: {
            required: true
        },
        serviceLevelId: {
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    }
}
</script>
